(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusDialogController', TaxStatusDialogController);

    TaxStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxStatus'];

    function TaxStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxStatus) {
        var vm = this;
        vm.taxStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxStatus.id !== null) {
                TaxStatus.update(vm.taxStatus, onSaveSuccess, onSaveError);
            } else {
                TaxStatus.save(vm.taxStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
